
import { Exhibit } from '../types';

export const cityLandmarkExhibits: Exhibit[] = [
  {
    id: 16,
    numberCode: "501",
    titleEn: "Historic City Square",
    titleHe: "כיכר העיר ההיסטורית",
    descriptionEn: "The central historic square dating back to the 18th century, surrounded by remarkable architecture and city monuments.",
    descriptionHe: "הכיכר המרכזית ההיסטורית שהוקמה במאה ה-18, מוקפת באדריכלות מרשימה ואנדרטאות העיר.",
    image: "https://images.unsplash.com/photo-1577081320692-6eedcf4b7902",
    hasAudio: true,
    hasVideo: true,
    location: {
      floor: 0,
      room: "Outdoor Location",
      latitude: 32.0730, // Central Tel Aviv coordinates
      longitude: 34.7925
    }
  },
  {
    id: 17,
    numberCode: "502",
    titleEn: "Modern Art Installation",
    titleHe: "מיצב אמנות מודרני",
    descriptionEn: "A striking contemporary art installation that transforms the urban landscape and reflects on modern society.",
    descriptionHe: "מיצג אמנות עכשווי מרהיב המשנה את הנוף העירוני ומשקף את החברה המודרנית.",
    image: "https://images.unsplash.com/photo-1518998053901-5348d3961a04",
    hasAudio: true,
    hasVideo: false,
    location: {
      floor: 0,
      room: "Outdoor Location",
      latitude: 32.0760,
      longitude: 34.7900
    }
  },
  {
    id: 18,
    numberCode: "503",
    titleEn: "Botanical Gardens",
    titleHe: "גנים בוטניים",
    descriptionEn: "An urban oasis featuring rare plant species and beautifully landscaped areas representing different global ecosystems.",
    descriptionHe: "נווה מדבר עירוני המציג מיני צמחים נדירים ואזורים מעוצבים המייצגים מערכות אקולוגיות גלובליות שונות.",
    image: "https://images.unsplash.com/photo-1585320806297-9794b3e4eeae",
    hasAudio: true,
    hasVideo: true,
    location: {
      floor: 0,
      room: "Outdoor Location",
      latitude: 32.0785,
      longitude: 34.7870
    }
  },
  {
    id: 19,
    numberCode: "504",
    titleEn: "Waterfront Sculpture Park",
    titleHe: "פארק פסלים על קו המים",
    descriptionEn: "A collection of large-scale sculptures situated along the waterfront, creating a dialogue between art and nature.",
    descriptionHe: "אוסף של פסלים בקנה מידה גדול הממוקמים לאורך קו המים, ויוצרים דיאלוג בין אמנות לטבע.",
    image: "https://images.unsplash.com/photo-1564399579883-551a1b76e6d5",
    hasAudio: false,
    hasVideo: true,
    location: {
      floor: 0,
      room: "Outdoor Location",
      latitude: 32.0810,
      longitude: 34.7850
    }
  },
  {
    id: 20,
    numberCode: "505",
    titleEn: "Historic Lighthouse",
    titleHe: "מגדלור היסטורי",
    descriptionEn: "A 19th-century lighthouse that has guided ships safely to shore for generations and offers panoramic views of the coastline.",
    descriptionHe: "מגדלור מהמאה ה-19 שהנחה ספינות בבטחה לחוף במשך דורות ומציע נוף פנורמי של קו החוף.",
    image: "https://images.unsplash.com/photo-1577130009278-0b1779e8d02d",
    hasAudio: true,
    hasVideo: false,
    location: {
      floor: 0,
      room: "Outdoor Location",
      latitude: 32.0830,
      longitude: 34.7830
    }
  }
];
